<template>
	<div>
	<b-table-simple hover striped small responsive class="mb-0">
		<b-thead>
			<b-tr>
				<b-th>
					<span id="class-skills-label"><font-awesome-icon icon="chevron-down"></font-awesome-icon> Class Skill</span>
				</b-th>
				<b-th>Total</b-th>
				<b-th>Ranks</b-th>
				<b-th>Ability</b-th>
				<b-th>Other</b-th>
				<b-th></b-th>
			</b-tr>
		</b-thead>
		<b-tbody>
			<b-tr v-for="(skill, skillID) in skillsUsed" :key="skill.name">
				<b-th scope="row">
					<font-awesome-icon :icon="['far', 'check-square']" v-if="skill.class_skill"></font-awesome-icon>
					<font-awesome-icon :icon="['far', 'square']" v-else></font-awesome-icon>
					<span class="pl-1" v-if="skill.Name == undefined">{{skill.name}}{{(skill.armor_check?'*':'')}}</span>
					<span class="pl-1" v-else>Profession ({{skill.name}})</span>
				</b-th>
				<b-td class="table-active">{{skillsTotal[skillID]|positivePad}}</b-td>
				<b-td>{{skillsRanks[skillID]|positivePad}}</b-td>
				<b-td>{{abilityMods[skill.ability]|positivePad}}</b-td>
				<b-td>{{skillsOther[skillID]|positivePad}}</b-td>
				<b-td class="rollers">
					<dice-button :data-dice-notation="skillsTotal[skillID] + ' ' + skill.name| d20roll"></dice-button>
				</b-td>
			</b-tr>
		</b-tbody>
		<b-tfoot>
			<b-tr>
				<b-th colspan="6">* Armor Check Penalty applied</b-th>
			</b-tr>
		</b-tfoot>
	</b-table-simple>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'
import DiceButton from '@/components/DiceButton.vue'

export default {
	components: {
		'DiceButton': DiceButton,
	},
	computed: {
		Character: function(){
			return this.$store.state.Character
		},
		...mapGetters('character/abilityScores',[
			'abilityMods'
		]),
		...mapGetters('character/skills',{
			skillsUsed: 'used',
			skillsRanks: 'ranks',
			skillsOther: 'other',
			skillsTotal: 'total',
		})
	}
}
</script>

<style scoped>
#class-skills-label {
	font-size: small;
}
</style>